import { defineRule, configure } from "vee-validate";
import {
  required,
  email,
  min,
  max,
  numeric,
  alpha,
  alpha_num,
  alpha_spaces,
  confirmed,
  digits,
  dimensions,
  ext,
  image,
  regex,
  size,
  url,
} from "@vee-validate/rules";
import { localize } from "@vee-validate/i18n";
import ru from "@vee-validate/i18n/dist/locale/ru.json";
import moment from "moment";
import { getUsersClearRequest } from "@/helpers/api/user";

export function initValidation() {
  configure({
    generateMessage: localize("ru", ru),
    validateOnInput: false,
    validateOnChange: true,
    validateOnBlur: true,
    validateOnModelUpdate: false,
    bails: false,
  });
  defineRule("required", required);
  defineRule("requiredBoolean", (value) => {
    const valid = value !== null && value !== undefined;
    return valid || "Поле обязательно для заполнения";
  });
  defineRule("email", email);
  defineRule("min", min);
  defineRule("max", max);
  defineRule("numeric", numeric);
  defineRule("alpha", alpha);
  defineRule("alpha_num", alpha_num);
  defineRule("alpha_spaces", alpha_spaces);
  defineRule("confirmed", confirmed);
  defineRule("digits", digits);
  defineRule("dimensions", dimensions);
  defineRule("ext", ext);
  defineRule("image", image);
  defineRule("regex", regex);
  defineRule("size", size);
  defineRule("url", url);

  defineRule("price", (value) => {
    const priceRegExp = new RegExp("^\\d*\\.?\\d{0,2}$");
    const isValid = typeof value === "string" && priceRegExp.test(value);
    return isValid || "цена должна содержать только рубли и копейки";
  });

  defineRule("file", (value) => {
    const isValid = value && value[0] && value[0].size > 10;
    return isValid || "Файл не может быть пустым";
  });

  defineRule("promocode", (value) => {
    const isValid = value && value.length >= 8;
    return isValid || "Введите не менее 8 символов";
  });

  defineRule("promocodePeriod", (value) => {
    const isValid = value >= 0 && value <= 90;
    return isValid || "Убедитесь, что введённое значение меньше или равно 90";
  });

  defineRule("promocodePrecent", (value) => {
    const isValid = value >= 5 && value <= 100;
    return (
      isValid ||
      "Убедитесь, что введённое значение попадает в диапазон от 5 до 100"
    );
  });

  defineRule("isEmpty", (value) => {
    const isValid = value > 0;
    return isValid || "Убедитесь, что введённое значение больше 0";
  });

  defineRule("duractionDays", (value) => {
    const date = new Date();
    const outputDate = `${date.getUTCFullYear()} ${
      date.getUTCMonth() + 1
    } ${date.getUTCDate()} `;
    const isValid =
      moment(value, "YYYY MM DD").unix() >=
      moment(outputDate, "YYYY M D").unix();
    return (
      isValid ||
      "Убедитесь, что дата начала активации текущее число либо более позднее"
    );
  });

  defineRule("number", (value) => {
    const priceRegExp = new RegExp("^[0-9]*$");
    const isValid =
      typeof value === "number" ||
      (typeof value === "string" && priceRegExp.test(value));
    return isValid || "Вводите только цифры";
  });

  defineRule("phone", (value) => {
    const phoneRegExp = new RegExp(
      "^(\\+7|7|8)?[\\s\\-]?\\(?[489][0-9]{2}\\)?[\\s\\-]?[0-9]{3}[\\s\\-]?[0-9]{2}[\\s\\-]?[0-9]{2}$",
    );
    const isValid = typeof value === "string" && phoneRegExp.test(value);
    return isValid || "Телефон должен соответствовать виду +7 (XXX) XXX-XX-XX";
  });

  defineRule("all_phone", (value) => {
    const phoneRegExp = new RegExp(
      "^(\\+7|7|8)?[\\s\\-]?\\(?[0-9][0-9]{2}\\)?[\\s\\-]?[0-9]{3}[\\s\\-]?[0-9]{2}[\\s\\-]?[0-9]{2}$",
    );
    const isValid = typeof value === "string" && phoneRegExp.test(value);
    return isValid || "Телефон должен соответствовать виду +7 (XXX) XXX-XX-XX";
  });

  // Исправляем определение uniquePhone для vee-validate 4.x
  defineRule("uniquePhone", async (value) => {
    try {
      const response = await getUsersClearRequest({
        query: {
          phone_number: value.replace(/[^\d+]/g, "").slice(0, 13),
        },
      });

      if (response.data.count === 0) {
        return true;
      } else {
        return "Данный номер уже используется, введите его выше для выбора существующего пользователя";
      }
    } catch (error) {
      return "Ошибка доступа к серверу";
    }
  });
}
